/**
 * The one place the app leaves for another URL or hands the browser a file (CNPWKS-0003 C6,
 * CNPWKS-0012 V10). Tests spy on `browser.assign` and `browser.download`.
 */
export const browser = {
  assign(url: string): void {
    window.location.assign(url);
  },
  /** Saves a same-origin object URL as a file. Tests spy on `browser.download`. */
  download(url: string, filename: string): void {
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.rel = 'noopener';
    document.body.append(a);
    a.click();
    a.remove();
  },
};
